import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faBox } from "@fortawesome/free-solid-svg-icons"; // Import icons (adjust if using different library)

const MRList = ({ MRs, selectedIndex, onSelectMR }) => {
  // Helper to get status badge color based on MR.status (customize as needed)
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Received":
        return "bg-yellow-100 text-yellow-800"; // Warning
      case "Verified":
        return "bg-blue-100 text-blue-800"; // Info
      case "Rejected":
        return "bg-red-100 text-red-800"; // Action
      case "RFQ Created":
        return "bg-green-100 text-green-800"; // Success
      case "Cancelled":
        return "bg-orange-100 text-orange-800"; // Cancelled  
      default:
        return "bg-gray-100 text-gray-800"; // Default
    }
  };



  if (MRs.length === 0) {
    return (
      <div className="flex-1 overflow-y-auto mb-3">
        <div className="p-2">
          <div className="space-y-2">
            <div className="text-center py-8">
              <div className="text-gray-400 text-4xl mb-3">
                {/* Replace with your icon library; e.g., FontAwesome faFileAlt for MR */}
                <FontAwesomeIcon icon={faBox} /> {/* Or use faSearch if preferred */}
              </div>
              <p className="text-gray-500 text-sm">No MRs available</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto mb-10">
      <div className="p-2">
        <div className="space-y-2">
          {MRs.map((MR, index) => {
            const isActive = index === selectedIndex;
            return (
              <div
                key={MR.mr_number}
                onClick={() => onSelectMR(MR, index)}
                className={`p-3 rounded-lg cursor-pointer transition-all duration-200 border mb-3 ${
                  isActive
                    ? "bg-gray-100 border-gray-300 shadow-sm"
                    : "hover:bg-gray-50 border-gray-200 hover:border-gray-300"
                }`}
              >
                {/* Main Content: Flex between info and badge */}
                <div className="flex justify-between items-start">
                  <div className="flex-1 min-w-0">
                    {/* MR Header */}
                    <h4 className="font-medium text-gray-900 text-sm truncate">
                      {MR.mr_number}
                    </h4>
                    
                    {/* Customer Name */}
                    <p className="text-xs text-gray-600 mt-1 truncate">
                      {MR?.customer?.customer_name || MR?.customer_name ||  "N/A"}
                    </p>
                    
                    {/* Customer Phone (like email in example) */}
                    <p className="text-xs text-gray-500 truncate">
                      {MR?.customer?.mobile_number || MR?.customer_mobile_number || "No Phone"}
                    </p>

                     <p className="text-xs text-gray-500 truncate">
                     uploaded: <b>{MR.created_at}</b>
                    </p>
                  </div>
                  
                  {/* Status Badge (right side, like Active/Inactive) */}
                  <div className="flex-shrink-0 ml-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        getStatusBadgeClass(MR.status)
                      }`}
                    >
                      {MR.status}
                    </span>
                  </div>
                </div>
                
                {/* Bottom Metrics Section (like categories/products) */}
              {/*   <div className="flex justify-between text-xs text-gray-500 mt-3 pt-2 border-t border-gray-100">
                  <span className="flex items-center gap-1" title="Number of assigned vendors">
                    <FontAwesomeIcon icon={faUsers} className="text-gray-400" />
                    <span className="font-medium">{MR.vendor_ids?.length || 0}</span>
                    <span className="text-gray-400">Vendors</span>
                  </span>
                  <span className="flex items-center gap-1" title="Number of material requirements">
                    <FontAwesomeIcon icon={faBox} className="text-gray-400" />
                    <span className="font-medium">{MR.responses?.length || 0}</span>
                    <span className="text-gray-400">Responded</span>
                  </span>
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MRList;
